import React, { FC } from 'react';
import { ReactComponent as CategoryTwo } from 'assets/icons/settings_cat_2.svg';
import { ReactComponent as CategoryThree } from 'assets/icons/local_gas_station_cat_3.svg';
import { ReactComponent as CategorySeven } from 'assets/icons/directions_car_category_7.svg';
import { ReactComponent as CategoryEight } from 'assets/icons/apartment_category_8.svg';
import { ReactComponent as CategoryTen } from 'assets/icons/factory_cat_10.svg';
import { ReactComponent as CategoryEleven } from 'assets/icons/inventory_cat_11.svg';
import { ReactComponent as CategoryTwelve } from 'assets/icons/dustbin_cat_12.svg';
import { ReactComponent as CategoryThirteen } from 'assets/icons/cat_13.svg';
import { ReactComponent as CategoryFourteen } from 'assets/icons/franchise_cat_14.svg';
import { ReactComponent as CategoryFifteen } from 'assets/icons/money_bag_cat_15.svg';
import { ManualScope3Category } from 'constants/Scope3Constants/manualScope3Categories.constants';

export const MANUAL_SCOPE3_CATEGORY_ICONS: Record<
  ManualScope3Category,
  FC<React.SVGProps<SVGSVGElement>>
> = {
  category_2: CategoryTwo,
  category_3: CategoryThree,
  category_7: CategorySeven,
  category_8: CategoryEight,
  category_10: CategoryTen,
  category_11: CategoryEleven,
  category_12: CategoryTwelve,
  category_13: CategoryThirteen,
  category_14: CategoryFourteen,
  category_15: CategoryFifteen,
};
